/*
 * @Author: yinbing.liu
 * @Date: 2023-09-20 13:59:54
 * @LastEditors: liuYingBing
 * @LastEditTime: 2024-09-29 16:58:19
 * @FilePath: /fushigi/src/router/components.ts
 * @Description:
 */
export const Account = () => import('@/views/account/index.vue')
export const Personal = () => import('@/views/identification/Personal.vue')
export const Enterprise = () => import('@/views/identification/Enterprise.vue')
export const Gpu = () => import('@/views/gpu/index.vue')
export const Apply = () => import('@/views/apply/index.vue')
export const Purchase = () => import('@/views/purchase/index.vue')
export const CloudLayout = () => import('@/views/cloud/CloudLayout.vue')
export const SdLayout = () => import('@/views/sd/SdLayout.vue')
export const CenterLayout = () => import('@/views/console/CenterLayout.vue')
export const GenericLayout = () => import('@/views/console/GenericLayout.vue')
export const IpvmLayout = () => import('@/views/console/IpvmLayout.vue')
export const Gpus = () => import('@/views/apparatus/gpu/gpu.vue')
export const Apps = () => import('@/views/apparatus/gpu/app.vue')
// export const Games = () => import('@/views/apparatus/game')
export const Generic = () => import('@/views/apparatus/generic')
export const Desktop = () => import('@/views/apparatus/desktop')
export const EBusiness = () => import('@/views/apparatus/eBusiness')

export const IpvmDetail = () =>
  import('@/views/apparatus/components/ApparatusLists/ipvmDetail/index.vue')

export const Disk = () => import('@/views/disk/index.vue')

export const Rdp = () => import('@/views/rdp/index.vue')
export const ImageShare = () => import('@/views/image/share.vue')
export const RdpS = () => import('@/views/rdp/rdp.vue')
export const ThirdLogin = () => import('@/views/third/index.vue')

export const Home = () => import('@/views/home/index.vue')
export const Layout = () => import('@/components/Layout.vue')

export const Mirror = () => import('@/views/gupData/mirror')

export const CouponPackage = () => import('@/views/couponPackage/index.vue')
export const Deposit = () => import('@/views/deposit/index.vue')
export const Bill = () => import('@/views/bill/index.vue')
export const BillStorageDetail = () => import('@/views/bill/storageCost/detail.vue')
export const BillServerDetail = () => import('@/views/bill/serverCost/detail.vue')

export const Recharge = () => import('@/views/account/recharge/index')
export const Finance = () => import('@/views/account/recharge/src/components/Finance.vue')

// 推理
export const Deduction = () => import('@/views/deduction/index.vue')
export const CreateData = () => import('@/views/deduction/components/create/createData.vue')
export const Diffusion = () => import('@/views/diffusion/index.vue')
export const DatasetDetails = () => import('@/views/deduction/components/datasetDetails/index.vue')
export const UploadImage = () => import('@/views/deduction/components/uploadImage/index.vue')

// 算力中心
export const ComputeDetail = () => import('@/views/computeCenter/detail/index.vue')
export const Computer = () => import('@/views/computeCenter/index.vue')
export const ComputerCombo = () => import('@/views/computeCenter/combo/index.vue')
export const Train = () => import('@/views/train/index.vue')

export const Workflow = () => import('@/views/workflow/index.vue')
